import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TrendingUp, Mail, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("admin@finakis.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav("/");
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 flex items-stretch grain-bg">
      <div className="hidden lg:flex flex-col justify-between flex-1 p-12 bg-gradient-to-br from-indigo-950 via-[#0F1522] to-slate-950 relative overflow-hidden">
        <div className="relative z-10">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-fuchsia-500 flex items-center justify-center">
              <TrendingUp className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-display text-xl font-extrabold tracking-tight">Finakış</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500">Nakit Akışı Takibi</div>
            </div>
          </div>
        </div>

        <div className="relative z-10 max-w-md">
          <div className="text-[10px] uppercase tracking-[0.3em] text-indigo-400 mb-3">Freelancer & KOBİ için</div>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
            Gelirinizi, gidernizi ve nakit akışınızı{" "}
            <span className="bg-gradient-to-r from-indigo-400 to-fuchsia-400 bg-clip-text text-transparent">tek yerden</span> yönetin.
          </h1>
          <p className="mt-6 text-slate-400 text-base leading-relaxed">
            Yaklaşan tahsilat ve ödemelerinizi takip edin, çoklu para birimi desteği ile anlık net pozisyonunuzu görün.
          </p>
          <div className="grid grid-cols-3 gap-3 mt-10">
            {[
              { k: "Çoklu", v: "Para Birimi" },
              { k: "Anlık", v: "Nakit Akışı" },
              { k: "Görsel", v: "Raporlar" },
            ].map((f, i) => (
              <div key={i} className="rounded-xl border border-white/5 bg-white/[0.02] p-3">
                <div className="font-display text-lg font-bold">{f.k}</div>
                <div className="text-xs text-slate-500">{f.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative z-10 text-xs text-slate-600">© 2026 Finakış</div>

        <div className="absolute -right-32 -top-32 w-96 h-96 bg-indigo-500/20 blur-3xl rounded-full" />
        <div className="absolute -left-20 bottom-10 w-72 h-72 bg-fuchsia-500/10 blur-3xl rounded-full" />
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-fuchsia-500 flex items-center justify-center">
              <TrendingUp className="w-5 h-5 text-white" />
            </div>
            <div className="font-display font-extrabold text-lg">Finakış</div>
          </div>

          <div className="text-[10px] uppercase tracking-[0.3em] text-indigo-400 mb-2">Giriş Yap</div>
          <h2 className="font-display text-3xl font-bold tracking-tight mb-2">Tekrar hoş geldiniz</h2>
          <p className="text-sm text-slate-400 mb-8">Finansal işlemlerinize kaldığınız yerden devam edin.</p>

          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400" htmlFor="email">E-posta</Label>
              <div className="relative mt-2">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="login-email-input"
                  className="pl-9 bg-[#131924] border-white/10 h-11"
                />
              </div>
            </div>

            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400" htmlFor="password">Şifre</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="login-password-input"
                  className="pl-9 bg-[#131924] border-white/10 h-11"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full h-11 bg-indigo-500 hover:bg-indigo-600 text-white font-semibold"
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>

            <div className="text-center text-sm text-slate-500">
              Hesabınız yok mu?{" "}
              <Link to="/register" data-testid="register-link" className="text-indigo-400 hover:text-indigo-300 font-medium">
                Hemen kaydolun
              </Link>
            </div>

            <div className="rounded-lg border border-white/5 bg-white/[0.02] p-3 text-xs text-slate-500">
              Demo: <span className="font-mono-num text-slate-300">admin@finakis.com</span> / <span className="font-mono-num text-slate-300">admin123</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
